<template>
  <div class="equip_tabs equip_detail">
    <a-spin :spinning="loding">
      <a-tabs type="card" style="background: #ffffff">
        <a-tab-pane :key="index" :tab="item.pName" v-for="(item, index) in parameTabsList">
          <parameter-information-description :model="item.children"></parameter-information-description>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </div>
</template>

<script>
import { getEquipmentBasicInfo, getParamValuesByEquipmentTypeAndId } from '@/api/equipmentLedger'
import ParameterInformationDescription
  from '@/views/equipmentLedger/modules/dataTabsModel/parameterInformationDescription.vue'
export default {
  components: {
    ParameterInformationDescription

  },
  props: {
    model: Object,
    parameTabsList: Array
  },
  watch: {
    model: {
      handler (model) {
        if (model) {
          // this.initData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      detail: {},
      loding: false
    }
  },
  methods: {
    initData () {
      const data = {
        "equipmentType": this.model.equipmentType,
        "equipmentId": this.model.id
      }
      if (!this.model.dblclickDisabled) {
        this.loding = true
        getParamValuesByEquipmentTypeAndId(data).then(res => {
          if (res.status === 0) {
            if (res.data) {
              this.detail = res.data
            }
          }
          this.loding = false
        }).catch(err => {
          this.loding = false
        })
      } else {
        this.detail = this.model
      }
    }
  }
}
</script>

<style lang="less" scoped>
.equip_tabs {
  margin-top: 1px;
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      padding-left: 8px;
      border-bottom: 1px solid #DDDDDD;
      // border: 0;

      // .ant-tabs-tab {
      //   border: 0;
      //   height: 26px;
      //   line-height: 26px;
      //   padding: 0 10px;
      //   margin: 7px 0;
      //   margin-right: 16px;
      //   font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      //   font-weight: 500;
      // }
      // .ant-tabs-tab-active {
      //   color: #1791FF;
      //   background: rgba(23, 145, 255, 0.1);
      // }
      .ant-tabs-tab {
        border: 0;
        height: 26px;
        // line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;

        background: rgba(255, 255, 255, 1) !important;
        font-size: 12px;
        color: #b3b3b3;
        line-height: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        background: rgba(255, 255, 255, 1) !important;
        font-size: 12px;
        color: #08409f !important;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
      }
    }
  }
}
.equip_detail{
  margin-left: -1px;
  margin-right: -1px;
  border-bottom: 1px solid #DDDDDD;
  /deep/.ant-descriptions{
    margin-bottom: -1px;
    .ant-descriptions-title{
      margin-bottom: 0;
      line-height: 32px;
      font-size: 12px;
      color: #08409F;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      padding: 0 12px;
      border-right: 1px solid #DDDDDD;
      // border-left: 1px solid #e8e8e8;
      background: #FFFFFF;
    }
    .ant-descriptions-view{
      border-radius: 0;
      width: 100%;
      border-color: #DDDDDD;
      // border-left: none;
      // border-right: none;
      .ant-descriptions-row{
        border-bottom: none;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          padding: 8px 12px;
          height: 40px;
          border-bottom: 1px solid #DDDDDD;
          border-color: #DDDDDD;
        }
        .ant-descriptions-item-label{
          background: rgba(8,64,159,0.1);
          width: calc(100% / 15);
        }
        .ant-descriptions-item-content[colspan="1"]{
          // width: 230px;
          width: calc(100% / 10);
        }
        .ant-descriptions-item-content[colspan="3"]{
          // width: 580px;
          width: calc(100% / 10 * 5);
        }
        .ant-descriptions-item-content[colspan="5"]{
          // width: 930px;
          width: calc(100% / 2);
        }
      }
      .ant-descriptions-row:last-child{
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          // border-bottom: none;
        }
      }

    }
  }
  /deep/.ant-descriptions:last-child{
    .ant-descriptions-view{
      border-bottom: none;
    }
  }
  /deep/ .ant-descriptions-item-label{
    text-align: center;
  }
}
</style>
